import React, { Component } from 'preact';
import { TG_WIDGET_HEADER_FOOTER } from '../../config/keys';
import StorageContext from '../../store/storage_context';

class Header extends Component {

    backLink = (e: any) => {
        e.preventDefault();

        const { theme, memberID } = this.context;

        if (theme?.ThemeID === 'apfm') {
            window.location.href = `https://www.aplaceformom.com/community/${memberID}`;

            return;
        }

        window.history.back();
    }

    renderBackLink = () => {
        return (
            <a href="#" onClick={(e) => this.backLink(e)} id="back-link">
                <i className="fa fa-chevron-left"></i> Back
            </a>
        );
    }

    renderLogo = () => {
        const { branding } = this.context;

        if (!branding) {
            return '';
        }

        const { SiteName, Logo } = branding;

        return <img className="logo" src={Logo} alt={SiteName} />
    }

    render() {
        const showHeader = localStorage.getItem(TG_WIDGET_HEADER_FOOTER);

        if (showHeader !== 'true') {
            return '';
        }

        return (
            <header id="header">
                <div className="container-fluid text-center">
                    { this.renderLogo() }
                    { this.renderBackLink() }
                </div>
            </header>
        );
    }
}

Header.contextType = StorageContext;
export default Header;
